/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Dns_InstructionsInputs */



/**
* | output |
* | --- |
* | "Create these DNS records for your domain. The TXT record proves you own it; the A and AAAA records send its traffic to oneAI." |
*
* @param {Canvas_Domain_Dns_InstructionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_dns_instructions = /** @type {((inputs?: Canvas_Domain_Dns_InstructionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Dns_InstructionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie diese DNS-Einträge für Ihre Domain. Der TXT-Eintrag weist Ihren Besitz nach, die A- und AAAA-Einträge leiten den Datenverkehr an oneAI weiter.")
	return /** @type {LocalizedString} */ ("Create these DNS records for your domain. The TXT record proves you own it; the A and AAAA records send its traffic to oneAI.")
});